import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { FormInput } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class Input extends Component {
  static propTypes = {
    ...FormInput.propTypes,
    formEntry: PropTypes.instanceOf(FormEntry),
    castValue: PropTypes.func,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isFixed: PropTypes.bool,
    isRequired: PropTypes.bool
  }

  static defaultProps = {
    isFixed: false,
    defaultValue: '',
    isRequired: false
  }

  state = {
    value: ''
  }

  handleOnChangeInput = e => {
    const { formEntry, castValue, isFixed } = this.props
    const value = castValue ? castValue(e.target.value) : e.target.value
    formEntry.updateValue(e.target.name, value, isFixed)
  }

  render () {
    const {
      formEntry,
      defaultValue,
      name,
      options,
      onChange,
      onBlur,
      castValue,
      parseValue,
      errorPointing,
      error,
      isFixed,
      isRequired,
      ...props
    } = this.props
    const value = formEntry.getValue(name, isFixed, defaultValue, isRequired)
    const hasError = formEntry.getError(name)
    return (
      <FormInput
        value={parseValue ? parseValue(value) : value}
        name={name}
        onChange={onChange || this.handleOnChangeInput}
        onBlur={onBlur}
        error={hasError}
        transparent={formEntry.readonly}
        readOnly={formEntry.readonly}
        {...props}
      />
    )
  }
}

export default Input
